export default __webpack_public_path__ + "static/media/404.7c8cda57.svg";